export const en: Record<string, string> = {
  "messages.inbox": "Inbox",
  "messages.archived": "Archived",
  "messages.typeMessage": "Type a message…",
  "messages.send": "Send",
  "messages.unread": "Unread",
  "messages.archiveConversation": "Archive Conversation",
  "notifications.title": "Notifications",
  "notifications.markAllRead": "Mark all read",
  "notifications.empty": "You’re all caught up.",
  "notifications.events.milestoneReleased": "Milestone released — you were paid",
  "notifications.events.contractCompleted": "Contract completed",
  "notifications.events.escrowFunded": "Escrow funded",
  "notifications.events.contractFullySigned": "Contract fully signed",
  "notifications.events.orderCancelled": "Order cancelled",
  "notifications.events.professionalApproved": "Professional verification approved",
  "notifications.events.orderReceived": "New order received",
  "notifications.events.purchaseConfirmed": "Purchase confirmed",
  "notifications.events.progressUpdate": "New progress update",
  "notifications.events.workerLoggedTime": "Worker logged time",
  "notifications.events.offerAccepted": "Offer accepted",
  "notifications.events.projectOfferAccepted": "Project offer accepted and signed",
  "notifications.events.hired": "You're hired!",
  "notifications.events.bidReceived": "New bid on your project",
  "notifications.events.reviewReceived": "New review",
  "notifications.events.bidAwarded": "🎉 Your bid was awarded!",
  "notifications.events.counterOffer": "New counter-offer",
  "support.contact": "Contact support",
  "support.reportProblem": "Report a problem",
  "support.newRequest": "New request",
  "safety.title": "Trust & Safety",
  "legal.terms": "Terms of Service",
  "legal.privacy": "Privacy Policy",
};

export const tl: Record<string, string> = {
  "messages.inbox": "Mga mensahe",
  "messages.archived": "Naka-archive",
  "messages.typeMessage": "Mag-type ng Mensahe",
  "messages.send": "Ipadala",
  "messages.unread": "Hindi Pa Nabasa",
  "messages.archiveConversation": "I-archive ang Usapan",
  "notifications.title": "Mga Abiso",
  "notifications.markAllRead": "Markahang Nabasa ang Lahat",
  "notifications.empty": "Wala kang bagong abiso.",
  "notifications.events.milestoneReleased": "Dumating na ang bayad",
  "notifications.events.contractCompleted": "Tapos na ang contract.",
  "notifications.events.escrowFunded": "Nasa escrow na ang pondo",
  "notifications.events.contractFullySigned": "Pirmado na ang kontrata",
  "notifications.events.orderCancelled": "Kinansela ang Order",
  "notifications.events.professionalApproved": "Na-approve na ang iyong Professional Verification.",
  "notifications.events.orderReceived": "May pumasok na bagong order",
  "notifications.events.purchaseConfirmed": "Nakumpirma ang pagbili",
  "notifications.events.progressUpdate": "bagong progress update",
  "notifications.events.workerLoggedTime": "Oras ng pag-log ng manggagawa",
  "notifications.events.offerAccepted": "Tinanggap ang offer!",
  "notifications.events.projectOfferAccepted": "Tinanggap at pinirmahan ang offer sa project",
  "notifications.events.hired": "Tanggap kana",
  "notifications.events.bidReceived": "May nag-bid sa iyong project",
  "notifications.events.reviewReceived": "Bagong Review",
  "notifications.events.bidAwarded": "Nanalo ang bid mo",
  "notifications.events.counterOffer": "May bagong nag-offer",
  "support.contact": "Makipag-ugnayan sa Suporta",
  "support.reportProblem": "Mag-ulat ng Problema",
  "support.newRequest": "Bagong kahilingan",
  "safety.title": "Tiwala at Kaligtasan",
  "legal.terms": "Mga Tuntunin ng Serbisyo",
  "legal.privacy": "Patakaran sa Privacy",
};
